<template>
  <v-form
    ref="shutdown">
    <v-flex
      xs12>
      <span
        class="grey--text font-weight-light">
        {{ $t('Line leak shutdown reasons') }}
      </span>
      <hr>
    </v-flex>
    <v-flex
      xs12>
      <v-switch
        v-model="shutdownMask3"
        :label="shutdownLldLabels[0]"
        data-testId="switch-shutdownLldLabels-0"
        readonly
        class="dover-input text-xs-center"
        @change="onShutdownLldChange"/>
    </v-flex>
    <v-flex
      xs12>
      <v-switch
        v-model="shutdownMask02"
        :label="shutdownLldLabels[1]"
        data-testId="switch-shutdownLldLabels-1"
        class="dover-input text-xs-center"
        @change="onShutdownLldChange"/>
    </v-flex>
    <v-flex
      xs12>
      <v-switch
        v-model="shutdownMask01"
        :label="shutdownLldLabels[2]"
        data-testId="switch-shutdownLldLabels-2"
        class="dover-input text-xs-center"
        @change="onShutdownLldChange"/>
    </v-flex>
    <v-flex
      xs12>
      <span
        data-testId="span-Other-shutdown-reasons"
        class="grey--text font-weight-light">
        {{ $t('Other shutdown reasons') }}
      </span>
      <hr>
    </v-flex>
    <v-data-table
      :headers="headers"
      :items="shutdownData"
      :no-data-text="`${ Maglink.NoDataMessage(false) }`"
      :no-results-text="`${ Maglink.NoDataMessage(true) }`"
      data-testId="data-table-Maglink-NoDataMessage"
      hide-actions>
      <template
        slot="headerCell"
        slot-scope="{ header }">
        <span
          class="dover-light-blue-color"
          v-text="header.text"/>
      </template>
      <template
        slot="items"
        slot-scope="{ index, item }">
        <tr :data-testId="'row-' + `${ index }`">
          <td data-testId="item-device">{{ deviceDesc(item.deviceType, item.deviceNumber) }}</td>
          <td data-testId="item-trigger">{{ eventName(item.deviceType, item.triggerStatus) }}</td>
          <td data-testId="item-delay">{{ delayHoursText(item.actionDelay) }}</td>
          <td data-testId="item-actions">
            <v-icon
              data-testId="item-icon-edit"
              small
              class="mr-2"
              @click="editShutdown(index+1, item)">
              mdi-pencil
            </v-icon>
            <v-icon
              data-testId="item-icon-delete"
              small
              @click="deleteShutdown(index+1, item)">
              mdi-delete
            </v-icon>
          </td>
        </tr>
      </template>
      <template slot="footer">
        <v-btn
          data-testId="btn-Add-STP-shutdown-reason"
          color="primary"
          flat
          @click="newShutdown">
          {{ $t('Add STP shutdown reason') }}
        </v-btn>
      </template>
    </v-data-table>
    <MaglinkComponentDialogYesNo
      :key="dialogYN.key"
      :component-key="dialogYN.componentKey"
      :dialog="dialogYN.show"
      :title="dialogYN.title"
      :label-text="dialogYN.labelText"
      :custom-par1="dialogYN.action"
      :custom-par2="dialogYN.result"
      data-testId="MaglinkComponentDialogYesNo-dialogYN"
      @dialogResultYesNo="onDialogResult"/>
    <v-dialog
      v-model="dialog"
      data-testId="dialog"
      width="800px"
      @keydown.esc="dialog = false">
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title>
          {{ $t('STP shutdown reason') }}
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form"
            v-model="isValidationOk"
            lazy-validation>
            <v-container
              py-0>
              <v-layout
                wrap>
                <v-flex
                  xs12
                  md6>
                  <v-select
                    v-model="shutdown.deviceCode"
                    :rules="rules.required"
                    :items="devices"
                    :label="`${ $t('Device') }`"
                    :readonly="shutdown.position !== 0"
                    data-testId="select-Device"
                    item-text="desc"
                    item-value="code"
                    class="dover-input"
                    @input="deviceChange"/>
                </v-flex>
                <v-flex
                  xs12
                  md4>
                  <v-select
                    v-model="shutdown.triggerStatus"
                    :rules="rules.trigger"
                    :items="eventsFiltered"
                    :label="`${ $t('Reason') }`"
                    :readonly="shutdown.position !== 0"
                    data-testId="select-Reason"
                    item-text="desc"
                    item-value="code"
                    class="dover-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md2>
                  <v-text-field
                    v-model.trim="actionDelay"
                    :rules="rules.minutes"
                    :label="`${ $t('Delay') + ' [' + $t('hh:mm') + ']' }`"
                    data-testId="text-field-Delay"
                    class="dover-input"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider/>

        <v-card-actions data-testId="card-actions">
          <v-flex
            xs10
            md10
            text-xs-right>
            <v-btn
              data-testId="btn-Cancel"
              color="primary"
              flat
              @click="closeDialog(false)">
              {{ $t('Cancel') }}
            </v-btn>
          </v-flex>
          <v-flex
            xs2
            md2
            text-xs-right>
            <v-btn
              :disabled="!isValidationOk"
              data-testId="btn-Save"
              color="secondary"
              flat
              @click="closeDialog(true)">
              {{ $t('Save') }}
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-flex
      xs12>
      <hr>
    </v-flex>
  </v-form>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    lld: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    },
    devices: {
      type: Array,
      required: true,
      default: () => []
    },
    siteInfo: {
      type: Object,
      required: true,
      default: () => {}
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    shutdownData: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data: () => ({
    isValidationOk: false,
    rules: {
      minutes: [ v => Vue.prototype.Maglink.RulesMinutes(v) ],
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ],
      trigger: [ v => Vue.prototype.Maglink.RulesRequiredPositive(v) ]
    },
    dialogYN: {
      key: 0,
      show: false,
      componentKey: '',
      title: '',
      labelText: '',
      action: '',
      result: ''
    },
    shutdownLldLabels: [],
    headers: [],
    dialog: false,
    shutdown: {
      position: 0,
      deviceCode: 0,
      deviceType: 0,
      deviceNumber: 0,
      triggerStatus: 0,
      actionType: 1,
      actionDelay: 0
    },
    actionDelay: '0',
    eventsTank: [],
    eventsSensor: [],
    eventsLine: []
  }),
  computed: {
    shutdownMask3: {
      get: function () {
        return true
      },
      set: function (value) {
        this.lld.shutdownEnableMask |= 0x01
      }
    },
    shutdownMask02: {
      get: function () {
        return (this.lld.shutdownEnableMask & 0x02) !== 0
      },
      set: function (value) {
        if (value) {
          this.lld.shutdownEnableMask |= 0x02
        } else {
          this.lld.shutdownEnableMask &= ~0x02
        }
      }
    },
    shutdownMask01: {
      get: function () {
        return (this.lld.shutdownEnableMask & 0x04) !== 0
      },
      set: function (value) {
        if (value) {
          this.lld.shutdownEnableMask |= 0x04
        } else {
          this.lld.shutdownEnableMask &= ~0x04
        }
      }
    },
    eventsFiltered () {
      return (this.shutdown.deviceType === 0 ? this.eventsTank : this.shutdown.deviceType === 1 ? this.eventsSensor : this.shutdown.deviceType === 4 ? this.eventsLine : {})
    }
  },
  watch: {
    options: {
      handler: function (newOptions, oldOptions) {
        this.eventsTank = []
        this.eventsSensor = []
        this.eventsLine = []
        if (this.eventsTank.length === 0 && newOptions !== undefined) {
          newOptions.tankEvents.slice(1).forEach(d => { this.eventsTank.push({ code: d.code, desc: this.$t(d.desc) }) })
          newOptions.sensorEvents.slice(1).forEach(d => { this.eventsSensor.push({ code: d.code, desc: this.$t(d.desc) }) })
          newOptions.lldEvents.slice(1).forEach(d => { this.eventsLine.push({ code: d.code, desc: this.$t(d.desc) }) })
        }
      },
      immediate: true
    },
    systemSettings: {
      handler: function (newSettings, oldSettings) {
        if (newSettings !== undefined) {
          this.shutdownLldLabels = [
            this.leakLabelFromGph(3.0) + ' ' + this.$t('leak detected') + ' (' + this.$t('always blocks STP') + ')',
            this.leakLabelFromGph(0.2) + ' ' + this.$t('leak detected'),
            this.leakLabelFromGph(0.1) + ' ' + this.$t('leak detected')
          ]
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.isValidationOk = false
    this.lld.shutdownEnableMask |= 0x01

    this.headers = [
      { sortable: false, text: this.$t('Device') },
      { sortable: false, text: this.$t('Reason') },
      { sortable: false, text: this.$t('Delay') + ' [' + this.$t('hh:mm') + ']' },
      { sortable: false, text: '' }
    ]
  },
  methods: {
    leakLabel (leakValue) {
      var label = '' + this.Maglink.RoundFormat(this.Maglink.LeakageToDisplay(leakValue, this.systemSettings.volumeUnit), this.systemSettings.volumeUnit === 0 ? 2 : 1)
      label += ' ' + this.Maglink.LeakShortUdm(this.systemSettings.volumeUnit || 0)
      return label
    },
    leakLabelFromGph (leakValue) {
      return this.leakLabel(leakValue * 3.78541)
    },
    getDevice (type, number) {
      for (var i = 0; i < this.devices.length; i++) {
        if (this.devices[i].deviceType === type && this.devices[i].deviceNumber === number) {
          return this.devices[i]
        }
      }
      return undefined
    },
    getDeviceByCode (code) {
      for (var i = 0; i < this.devices.length; i++) {
        if (this.devices[i].code === code) {
          return this.devices[i]
        }
      }
      return undefined
    },
    deviceChange () {
      var device = this.getDeviceByCode(this.shutdown.deviceCode)
      if (device !== undefined) {
        this.shutdown.deviceType = device.deviceType
        this.shutdown.deviceNumber = device.deviceNumber
        this.shutdown.triggerStatus = 0
      }
    },
    deviceDesc (type, number) {
      var device = this.getDevice(type, number)
      if (device !== undefined) {
        return device.desc
      }
      return '-'
    },
    eventName (type, code) {
      var events = type === 0 ? this.eventsTank : type === 1 ? this.eventsSensor : type === 4 ? this.eventsLine : {}
      for (var i = 0; i < events.length; i++) {
        if (events[i].code === code) {
          return events[i].desc
        }
      }
      return '-'
    },
    delayHoursText (delay) {
      if (delay > 0) {
        return (Math.floor(delay / 60)).toString() + ':' + ((delay % 60) < 10 ? '0' : '') + (delay % 60).toString()
      }
      return 0
    },
    parseDelayHours (delayText) {
      if (!delayText) {
        return 0
      }
      if (delayText.indexOf(':') > 0) {
        let data = delayText.split(':')
        return parseInt(data[0], 10) * 60 + parseInt(data[1], 10)
      } else {
        return parseInt(delayText, 10)
      }
    },
    deleteShutdown (position, item) {
      let text = this.$t('Do you want to DELETE this shutdown reason?')

      this.dialogYN.title = this.$t('STP shutdown').toUpperCase()
      this.dialogYN.labelText = text
      this.dialogYN.componentKey = 'delete'
      this.dialogYN.action = position.toString()
      this.dialogYN.result = 0
      this.dialogYN.show = true
    },
    onDialogResult (componentKey, result, action, par2) {
      this.dialogYN.show = false

      if (!result) return

      if (componentKey === 'delete') {
        this.shutdownData.splice(parseInt(action, 10) - 1, 1)
      }
      this.$emit('dataChanged', true)
    },
    newShutdown () {
      this.shutdown = { position: 0, deviceType: 0, deviceNumber: 0, triggerStatus: 0, actionDelay: 0 }
      this.actionDelay = '0'
      this.dialog = true
    },
    editShutdown (position, item) {
      this.shutdown = { position: position, deviceType: item.deviceType, deviceNumber: item.deviceNumber, triggerStatus: item.triggerStatus, actionDelay: item.actionDelay }
      this.shutdown.deviceCode = this.getDevice(item.deviceType, item.deviceNumber)
      this.actionDelay = this.delayHoursText(item.actionDelay)
      this.dialog = true
    },
    onShutdownLldChange () {
      this.$emit('dataChanged', true)
    },
    closeDialog (save) {
      if (save) {
        if (this.shutdown.triggerStatus === 0) {
          this.isValidationOk = false
          return
        }
        this.shutdown.actionDelay = this.parseDelayHours(this.actionDelay)
        var newShutdown = { deviceType: this.shutdown.deviceType, deviceNumber: this.shutdown.deviceNumber, triggerStatus: this.shutdown.triggerStatus, actionDelay: this.shutdown.actionDelay, actionType: 1 }
        if (this.shutdown.position === 0) {
          var exists = false
          for (var i = 0; i < this.shutdownData.length; i++) {
            if (this.shutdownData[i].deviceType === newShutdown.deviceType && this.shutdownData[i].deviceNumber === newShutdown.deviceNumber && this.shutdownData[i].triggerStatus === newShutdown.triggerStatus) {
              this.shutdownData[i].actionDelay = newShutdown.actionDelay
              exists = true
            }
          }
          if (!exists) {
            this.shutdownData.push(newShutdown)
          }
        } else {
          this.shutdownData[this.shutdown.position - 1].actionDelay = this.shutdown.actionDelay
        }
        this.$emit('dataChanged', true)
      }
      this.dialog = false
    },
    saveShutdown () {
      var shutdownSetup = { lldNumber: this.lld.lldNumber, triggerSources: this.shutdownData }
      this.Maglink.StpShutdownSetup(shutdownSetup)
        .then(response => {
          this.shutdownData = response.data.stpShutdowns
          let text = this.$t('Shutdown configured for LLD ' + this.lld.lldDescription)
          this.snack('success', text)
          this.saveShutdownEnable = false
        })
        .catch(error => (this.snack('error', error.message)))
    },
    snack (color, message) {
      message = this.$t('STP shutdown config') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
